import React from "react";

export const amplitudeClient = undefined;

export const bugsnagClient = {};

React.useLayoutEffect = React.useEffect; // hack to silence useLayoutEffect warning

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      info: null
    };
  }
  componentDidCatch(error, info) {
    console.error({ error, info });
    this.setState({ error, info });
  }
  render() {
    const { error } = this.state;
    if (error) {
      const { FallbackComponent } = this.props;
      if (FallbackComponent)
        return React.createElement(FallbackComponent, this.state);
      return null;
    }
    return this.props.children;
  }
}
